var _radialGradient, _circle, _radialGradient2, _circle2, _radialGradient3, _circle3, _radialGradient4, _path, _radialGradient5, _path2, _radialGradient6, _path3, _radialGradient7, _path4, _radialGradient8, _path5, _radialGradient9, _path6, _circle4, _path7, _circle5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmilingFaceWithHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Dj0xEJi~GZStM8z27iiBla",
    cx: 24,
    cy: 24,
    r: 18,
    fx: 23.905,
    fy: 16.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#ffd226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fdcd23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899,
    stopColor: "#f6bd1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#f0af13"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "url(#Dj0xEJi~GZStM8z27iiBla)"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Dj0xEJi~GZStM8z27iiBlb",
    cx: 36,
    cy: 27,
    r: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8400",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#ff8400",
    stopOpacity: 0
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 27,
    r: 5,
    fill: "url(#Dj0xEJi~GZStM8z27iiBlb)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Dj0xEJi~GZStM8z27iiBlc",
    cx: 12,
    cy: 27,
    r: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8400",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#ff8400",
    stopOpacity: 0
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 27,
    r: 5,
    fill: "url(#Dj0xEJi~GZStM8z27iiBlc)"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Dj0xEJi~GZStM8z27iiBld",
    cx: 23.988,
    cy: 29.43,
    r: 5.577,
    fx: 23.984,
    fy: 29.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#ffe16e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe16e",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dj0xEJi~GZStM8z27iiBld)",
    d: "M24,33c-4.106,0-5.336-1.456-5.336-1.456S19.98,35,24,35l0-0.001V35 c4.02,0,5.336-3.456,5.336-3.456S28.106,33,24,33z"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Dj0xEJi~GZStM8z27iiBle",
    cx: 24.046,
    cy: 31.778,
    r: 5.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#cc9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc9000",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dj0xEJi~GZStM8z27iiBle)",
    d: "M24,35c-3.51,0-5-2.767-5-2.767S20.058,37,24,37s5-4.767,5-4.767S27.51,35,24,35z"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Dj0xEJi~GZStM8z27iiBlf",
    cx: 24,
    cy: 28.913,
    r: 15.654,
    gradientTransform: "matrix(-.35 0 0 .1877 32.4 26.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c1911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#171714"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dj0xEJi~GZStM8z27iiBlf)",
    d: "M19.299,30.805c-0.501-0.276-0.995,0.358-0.608,0.779C19.815,32.806,21.542,34,24,34 s4.185-1.194,5.309-2.416c0.387-0.421-0.107-1.055-0.608-0.779C27.55,31.441,25.976,32,24,32S20.45,31.441,19.299,30.805z"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Dj0xEJi~GZStM8z27iiBlg",
    cx: 35.039,
    cy: 8.227,
    r: 5.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#fb6c59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#ec4023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e62f0e"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dj0xEJi~GZStM8z27iiBlg)",
    d: "M39.273,6C37.92,6,37,6.909,37,6.909S36.085,6,34.727,6C33.221,6,32,7.221,32,8.727 c0,2.727,5,5.455,5,5.455s5-2.727,5-5.455C42,7.221,40.779,6,39.273,6z"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Dj0xEJi~GZStM8z27iiBlh",
    cx: 37.431,
    cy: 34.905,
    r: 4.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#fb6c59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#ec4023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e62f0e"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dj0xEJi~GZStM8z27iiBlh)",
    d: "M40.818,33C39.736,33,39,33.727,39,33.727S38.268,33,37.182,33C35.977,33,35,33.977,35,35.182 C35,37.364,39,40,39,40s4-2.636,4-4.818C43,33.977,42.023,33,40.818,33z"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "Dj0xEJi~GZStM8z27iiBli",
    cx: 6.646,
    cy: 31.672,
    r: 6.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#fb6c59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    stopColor: "#ec4023"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e62f0e"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Dj0xEJi~GZStM8z27iiBli)",
    d: "M11.727,29C10.104,29,9,30.091,9,30.091S7.902,29,6.273,29C4.465,29,3,30.465,3,32.273 c0,3.273,6,6.545,6,6.545s6-3.273,6-6.545C15,30.465,13.535,29,11.727,29z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 22.5,
    r: 0.5,
    fill: "#212121"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M27.742,22.939c0,0,1.726-0.944,3.258-0.944s3.258,0.944,3.258,0.944l0.631-0.754 c0,0-1.765-2.185-3.889-2.185s-3.889,2.185-3.889,2.185L27.742,22.939z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 22.5,
    r: 0.5,
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 22.5,
    r: 0.5,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M13.742,22.939c0,0,1.726-0.944,3.258-0.944s3.258,0.944,3.258,0.944l0.631-0.754 c0,0-1.765-2.185-3.889-2.185s-3.889,2.185-3.889,2.185L13.742,22.939z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 22.5,
    r: 0.5,
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilingFaceWithHearts);
export default __webpack_public_path__ + "static/media/smiling-face-with-hearts.ea780dd34626dca70d06c08899f19b28.svg";
export { ForwardRef as ReactComponent };